import { render } from "./ModifierConsultant.vue?vue&type=template&id=277630e4&scoped=true"
import script from "./ModifierConsultant.vue?vue&type=script&lang=js"
export * from "./ModifierConsultant.vue?vue&type=script&lang=js"

import "./ModifierConsultant.vue?vue&type=style&index=0&id=277630e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277630e4"]])

export default __exports__